<template>
  <div>
    <Card title="Basic Information" icon="mdi-currency-usd">
      <EditableObject
        :object="financialModule"
        :fields="[{fieldName:'name', displayName: 'Name', editable: true, type: String, rules:[rules.required]}]"
        :save-method="(data) => this.$api.financial.saveFinancialModule(data)"
        :delete-method="() => $api.financial.deleteFinancialModule(financialModule)"
        :success-callback="(response) => { if (!response) $router.push('/') }"
      />
      <v-divider/>
      <div class="px-4 pt-4 pb-2">
        <v-text-field
          label="Receipt forwarding address"
          :value="receiptEmailHook ? receiptEmailHook.emailAddress : ''"
          :loading="loadingReceiptEmailHook"
          readonly
          outlined
          persistent-hint
          hint="Forward emailed receipts and order confirmations here to improve transaction details and suggestions."
          append-icon="mdi-content-copy"
          @click:append="copyReceiptEmailAddress"
        />
        <div class="d-flex justify-end">
          <ButtonWithConfirmation
            button-text="Regenerate"
            button-icon="mdi-refresh"
            button-color="warning"
            confirmation-text="Regenerate the receipt forwarding address?"
            confirmation-icon="mdi-email-sync"
            confirmation-button-text="Regenerate"
            :disabled="!receiptEmailHook"
            :action="regenerateReceiptEmailAddress"
          />
        </div>
      </div>
    </Card>

    <Card title="Income Sources" icon="mdi-cash-marker">
      <EditableTable
        hideFilter
        :table-subscription="(handler) => this.$api.financial_income_source.subscribeToIncomeSources(financialModule.id, handler)"
        :fields="[
          {fieldName:'id', displayName: 'Id', type: String},
          {fieldName:'name', displayName: 'Name', editable: true, type: String, rules:[]},
          {fieldName:'keywordsCSV', displayName: 'Keywords', editable: true, type: String, rules:[]},
          // {fieldName:'friendlyKey', displayName: 'Key', editable: false, type: String, rules:[]},
          // {fieldName:'enabled', displayName: 'Enabled', editable: false, type: Boolean, rules:[]},
          ]"
        :save-method="(data) => this.$api.financial_income_source.saveIncomeSource(data)"
      />
      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" fab :elevation="0" @click="showCreateIncomeSourceDialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-actions>
    </Card>
    <Permissions :id="financialModule.id" type="financialmodule" showHeaderDivider/>

    <v-dialog v-model="showCreateIncomeSourceDialog" max-width="500px">
      <Card title="Create Income Source" icon="mdi-plus" inDialog>
        <DynamicForm
          :key="showCreateIncomeSourceDialog"
          :object="{financialModuleId: financialModule.id, name: '', keywordsCSV: ''}"
          :fields="[
              {fieldName:'name', displayName: 'Name', placeholderFieldName: 'officialName', type: String, rules:[rules.required]},
            ]"
          :save-method="(data) => {
              return this.$api.financial_income_source.createIncomeSource(data);
            }"
          :cancel-callback="() => this.showCreateIncomeSourceDialog = false"
          :success-callback="(o) => {this.showCreateIncomeSourceDialog = false}"
          :focus-index="0"
        ></DynamicForm>
      </Card>
    </v-dialog>

  </div>
</template>

<script>
  import EditableObject from '@/components/EditableObject'
  import Card from '@/components/Card'
  import Permissions from '@/components/Permissions'
  import EditableTable from '@/components/EditableTable.vue'
  import DynamicForm from '@/components/DynamicForm.vue'
  import ButtonWithConfirmation from '@/components/ButtonWithConfirmation.vue'
  export default {
    name: 'Settings',
    components: { ButtonWithConfirmation, DynamicForm, EditableTable, Permissions, Card, EditableObject },
    props: ['household', 'financialModule', 'incomeSources'],

    data: () => ({
      showCreateIncomeSourceDialog: false,
      receiptEmailHook: null,
      loadingReceiptEmailHook: false,
      rules: {
        required: value => !!value || 'Required',
      }
    }),

    methods: {
      loadReceiptEmailAddress() {
        if (!this.financialModule)
          return;
        this.loadingReceiptEmailHook = true;
        this.$api.financial.readFinancialModuleReceiptEmailHook(this.financialModule.id)
          .then(emailHook => {
            this.receiptEmailHook = emailHook;
          })
          .finally(() => {
            this.loadingReceiptEmailHook = false;
          });
      },
      regenerateReceiptEmailAddress() {
        return this.$api.financial.regenerateFinancialModuleReceiptEmailHook(this.financialModule.id)
          .then(emailHook => {
            this.receiptEmailHook = emailHook;
          });
      },
      copyReceiptEmailAddress() {
        if (!this.receiptEmailHook)
          return;
        if (!navigator.clipboard) {
          this.$api.emitError('Clipboard access is not available in this browser');
          return;
        }
        navigator.clipboard.writeText(this.receiptEmailHook.emailAddress).catch(() => {
          this.$api.emitError('Could not copy receipt forwarding address');
        });
      },
    },

    mounted() {
      this.$emit('breadcrumbs', []);
      this.$emit('resetMenu');
      this.loadReceiptEmailAddress();
    },
  }
</script>

<style scoped>

</style>
